import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import type { Occurrence } from "@/lib/scheduled";
import { monthLabel } from "@/lib/format";

export type Scope = "one" | "all";

export function ConfirmDialog({ open, title, text, confirm, onClose, onConfirm, testId, cancel = "Cancelar", onCancel }: { open: boolean; title: string; text: string; confirm: string; onClose: () => void; onConfirm: () => void; testId: string; cancel?: string; onCancel?: () => void }) {
  return (
    <Dialog open={open} onOpenChange={(v: boolean) => { if (!v) onClose(); }}>
      <DialogContent className="bg-white sm:max-w-md" data-testid={testId}>
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-[#1B2A4A]" data-testid={`${testId}-title`}>{title}</DialogTitle>
          <DialogDescription data-testid={`${testId}-text`}>{text}</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          <Button variant="outline" className="h-11" onClick={onCancel ?? onClose} data-testid={`${testId}-cancel`}>{cancel}</Button>
          <Button className="h-11 bg-[#1B2A4A] text-white hover:bg-[#2A3D63]" onClick={onConfirm} data-testid={`${testId}-confirm`}>{confirm}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function AheadDialog({ o, onClose, onConfirm }: { o: Occurrence | null; onClose: () => void; onConfirm: () => void }) {
  const month = o?.pending_date ? monthLabel(o.pending_date.slice(0, 7)) : "";
  const inflow = o?.type === "income";
  return (
    <Dialog open={!!o} onOpenChange={(v: boolean) => { if (!v) onClose(); }}>
      <DialogContent className="bg-white sm:max-w-md" data-testid="scheduled-ahead-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-[#1B2A4A]" data-testid="scheduled-ahead-text">Tienes pendiente el pago de {month}. ¿Quieres marcar este de todos modos?</DialogTitle>
          <DialogDescription>Se registra hoy y el pago de {month} sigue pendiente.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          <Button variant="outline" className="h-11" onClick={onClose} data-testid="ahead-cancel">Cancelar</Button>
          <Button className="h-11 bg-[#1B2A4A] text-white hover:bg-[#2A3D63]" onClick={onConfirm} data-testid="ahead-confirm">{inflow ? "Sí, cobrar este" : "Sí, pagar este"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function ScopeDialog({ action, onPick, onClose }: { action: "edit" | "delete" | null; onPick: (s: Scope) => void; onClose: () => void }) {
  return (
    <Dialog open={!!action} onOpenChange={(o: boolean) => { if (!o) onClose(); }}>
      <DialogContent className="bg-white sm:max-w-md" data-testid="scheduled-scope-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-[#1B2A4A]">¿Solo este pago o este y todos los siguientes?</DialogTitle>
          <DialogDescription>{action === "delete" ? "Los movimientos ya registrados no se borran." : "Los pagos ya registrados no cambian."}</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 sm:grid-cols-2">
          <Button variant="outline" className="h-11" onClick={() => onPick("one")} data-testid="scope-one">Solo este pago</Button>
          <Button className={`h-11 text-white ${action === "delete" ? "bg-[#B23A1E] hover:bg-[#8E2E18]" : "bg-[#1B2A4A] hover:bg-[#2A3D63]"}`} onClick={() => onPick("all")} data-testid="scope-all">Este y todos los siguientes</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
